<template>
  <div class="player-item">
    <div class="player-info">
      <div class="player-gender">
        <i
          :class="player.gender === 'male' ? 'fas fa-mars' : 'fas fa-venus'"
        ></i>
      </div>
      <div class="player-name">{{ player.name }}</div>
    </div>
    <button class="delete-btn" @click="$emit('remove')">
      <i class="fas fa-times"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "PlayerItem",
  props: {
    player: {
      type: Object,
      required: true,
    },
  },
  emits: ["remove"],
};
</script>

<style scoped>
.player-item {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-md);
  padding: var(--spacing-md);
  display: flex;
  align-items: center;
  justify-content: space-between;
  animation: fadeIn var(--transition-normal);
}

.player-info {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}

.player-gender {
  font-size: var(--font-size-lg);
  color: var(--accent-color);
}

.player-name {
  font-weight: 500;
}

.delete-btn {
  color: var(--error-color);
  background: none;
  border: none;
  cursor: pointer;
  font-size: var(--font-size-lg);
  transition: transform var(--transition-fast);
}

.delete-btn:hover {
  transform: rotate(90deg);
}
</style>
